import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

const STATUS_LABEL = {
  en_cours: "En cours",
  gagne: "Gagné",
  perdu: "Perdu",
  annule: "Annulé",
};

export default function Signals() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState(null);

  const load = async () => {
    setLoading(true);
    try {
      const d = await api.signals();
      setItems(d.items || []);
      api.confluenceStats().then(setStats).catch(() => {});
    } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const setStatus = async (id, status) => {
    try {
      await api.updateSignalStatus(id, status);
      toast.success("Statut mis à jour");
      load();
    } catch { toast.error("Erreur"); }
  };

  return (
    <div className="p-6">
      <div className="flex items-end justify-between mb-6">
        <div>
          <h1 className="font-heading font-bold text-2xl tracking-tight" data-testid="signals-title">Historique des Signaux</h1>
          <p className="text-white/50 text-sm mt-1">Suivi de vos alertes générées.</p>
        </div>
      </div>
      {stats && (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-5" data-testid="confluence-stats">
          {stats.buckets.map((b) => (
            <div key={b.key} className="panel p-3.5" data-testid={`confluence-stat-${b.key}`}>
              <div className="text-[10px] uppercase tracking-widest text-white/40 mb-1">{b.label}</div>
              <div className="flex items-baseline gap-2">
                <span className={`font-heading font-bold text-xl ${b.win_rate == null ? "text-white/30" : b.win_rate >= 55 ? "text-up" : b.win_rate >= 45 ? "text-white/80" : "text-down"}`}>
                  {b.win_rate == null ? "—" : `${b.win_rate}%`}
                </span>
                <span className="text-[10px] text-white/40">win-rate</span>
              </div>
              <div className="mt-1.5 h-1 rounded-full bg-white/5 overflow-hidden">
                <div
                  className={`h-full rounded-full ${b.win_rate >= 55 ? "bg-up" : b.win_rate >= 45 ? "bg-white/40" : "bg-down"}`}
                  style={{ width: `${b.win_rate || 0}%` }}
                />
              </div>
              <div className="text-[10px] text-white/40 mt-1.5">
                {b.closed > 0 ? `${b.wins}W / ${b.losses}L clôturés` : "Aucun signal clôturé"} · {b.total} total
              </div>
            </div>
          ))}
          <div className="col-span-2 lg:col-span-4 text-[10px] text-white/35 -mt-1">
            Win-rate calculé sur VOS signaux clôturés (Gagné/Perdu), groupés par niveau de confluence institutionnelle au moment de l&apos;alerte.
            Marquez le statut de vos signaux dans le tableau ci-dessous pour alimenter ces statistiques.
          </div>
        </div>
      )}
      <div className="panel overflow-hidden">
        <table className="dt" data-testid="signals-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Actif</th>
              <th>Timeframe</th>
              <th>Direction</th>
              <th>Entrée</th>
              <th>SL</th>
              <th>TP</th>
              <th>R:R</th>
              <th>Conf.</th>
              <th>🏛 Confluence</th>
              <th>Statut</th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={11} className="text-center text-white/40 py-10">Chargement…</td></tr>}
            {!loading && items.length === 0 && (
              <tr><td colSpan={11} className="text-center text-white/40 py-10">Aucun signal enregistré. Cliquez sur « M'alerter » dans le tableau de bord pour en créer un.</td></tr>
            )}
            {items.map((s) => (
              <tr key={s.id} data-testid={`signal-row-${s.id}`}>
                <td className="font-mono text-white/60 text-[11px]">{new Date(s.created_at).toLocaleString("fr-FR")}</td>
                <td className="font-medium">{s.symbol}</td>
                <td>{s.timeframe}</td>
                <td>
                  <span className={`chip ${s.direction === "ACHAT" ? "chip-up" : "chip-down"}`}>{s.direction}</span>
                </td>
                <td className="font-mono">{s.entry}</td>
                <td className="font-mono text-down">{s.stop_loss}</td>
                <td className="font-mono text-up">{s.take_profit}</td>
                <td className="font-mono">{s.risk_reward}</td>
                <td className="font-mono">{s.confidence}%</td>
                <td data-testid={`signal-confluence-${s.id}`}>
                  {s.inst_confluence && s.inst_confluence.max > 0 ? (
                    <span className={`chip ${s.inst_confluence.score === s.inst_confluence.max ? "chip-up" : "chip-neutral"}`}>
                      {s.inst_confluence.score}/{s.inst_confluence.max}
                    </span>
                  ) : (
                    <span className="text-white/30 text-xs">—</span>
                  )}
                </td>
                <td>
                  <select
                    className="field text-xs !py-1"
                    value={s.status}
                    onChange={(e) => setStatus(s.id, e.target.value)}
                    data-testid={`signal-status-${s.id}`}
                  >
                    {Object.entries(STATUS_LABEL).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                  </select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
